import { ControlError } from '../lib/util/ValidationSchemes/ValidationTypes';

export type SignUpForm = {
  country: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
};

export type SignUpFormWithPolicies = SignUpForm & {
  isPrivacyPolicyApproved: boolean;
  steps:{
    isPersonalInfoPassed:boolean;
    isAuthInfoPassed:boolean;
    isVerifyEmailPassed:boolean;
    isVerifyPhonePassed:boolean;
    isVerifyPhoneContinueSubmitted:boolean;
  }
};

export type SignUpFormErrors = {
  country: ControlError[];
  firstName: ControlError[];
  lastName: ControlError[];
  email: ControlError[];
  privacyPolicyError: string;
};

export type SignUpFormWithPoliciesErrors = SignUpFormErrors & {
};

export const SignUpFormWithPoliciesValue: SignUpFormWithPolicies = {
  country: '',
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  isPrivacyPolicyApproved: false,
  steps: {
    isPersonalInfoPassed: false,
    isAuthInfoPassed: false,
    isVerifyEmailPassed: false,
    isVerifyPhonePassed: false,
    isVerifyPhoneContinueSubmitted: false,
  },

};

export const DefaultSignUpFormWithPoliciesErrors: SignUpFormWithPoliciesErrors = {
  country: [],
  firstName: [],
  lastName: [],
  email: [],
  privacyPolicyError: '',
};
